import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class CIDRPanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.cidr_panel"
  };

  // -- RENDER -- //

  renderSummary = () => {
    const { id, formikProps, copyKey, copy } = this.props;

    const primeValue = get(formikProps, `values.${id}Prime`, null);
    const subValue = get(formikProps, `values.${id}Sub`, null);

    if (primeValue && subValue) {
      return `${primeValue}.${subValue}.0.0/16 - ${primeValue}.${subValue}.255.255/16`;
    }

    if (primeValue || subValue) {
      return copy(`${copyKey}.incomplete_value`);
    }

    const simpleValue = get(formikProps, `values.${id}`, null);
    if (simpleValue) {
      return `${simpleValue}.0.0/16 - ${simpleValue}.255.255/16`;
    }

    return null;
  };

  renderActive() {
    const { copyKey, copy } = this.props;

    return (
      <p>
        <strong>{copy(`${copyKey}.class_label`)}: </strong>
        {this.renderSummary()}
      </p>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    return this.renderActive();
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(CIDRPanelSummary);
